<template>
  <div>
    <h4 class="details-label mb-px-8 mt-0">{{ $t('study_sets.information') }}</h4>
    <read-aloud-info :readAloudDetails="readAloudDetails" :organizationType="organizationType" :organizationId="organizationId" />
    <h4 v-if="readAloudDetails.assigned_group" class="details-label mb-px-8 mt-px-16">{{ $t($i18nLabelsHelper(currentOrganizationType, `study_sets.assign_to_groups`)) }}</h4>
    <classes-assigned v-if="readAloudDetails.assigned_group" :readAloudDetails="readAloudDetails" :organizationType="organizationType" :organizationId="organizationId" />
  </div>
</template>


<script>
import ReadAloudInfo from './ReadAloudInfo'
import ClassesAssigned from './ClassesAssigned'
import { always } from 'ramda'
import { mapGetters } from 'vuex'

export default {
  components: {
    ReadAloudInfo,
    ClassesAssigned
  },
  props: {
    readAloudDetails: {
      type: Object,
      default: always({ users: [] })
    },
    organizationType: {
      type: String,
      default: ''
    },
    organizationId: {}
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      currentOrganizationType: 'organization/currentOrganizationType'
    })
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';
.details-label {
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  margin-bottom: 8px;
}
::v-deep .base-create-body {
  margin-top: 35px;
}

::v-deep .base-create-footer {
  margin-top: 24px;
}

::v-deep .generic-error-section {
  margin-bottom: 15px;
}
</style>
